var $ = require('jquery');


// we attempted to use the jquery 'scrollintoview' plugin,
// but it didn't work in Mobile Safari; somehow this works better


(function ($) {
    $.fn.scrollto = function(duration) {
        duration = duration || 1000;
        let overshoot = 5,
            stickyNav = null;

        // GEMGv2 sticky nav
        let $topBar = $('.top-bar-attached');
        if ($topBar.length) {
            overshoot += $topBar.height();
        }
        let $bottomBar = $('.bottom-bar-attached');
        if ($bottomBar.length) {
            overshoot += $bottomBar.height();
        }

        console.log('scrollto overshoot', overshoot);

        // D1 sticky nav
        stickyNav = $('.d1-sticky-nav-logo');
        if (stickyNav.length && $('.asmt-container.site-defenseone').length) {
            overshoot += stickyNav.height();
        }

        $('html, body').animate({ scrollTop: this.offset().top - overshoot }, duration);
        return this;
    };
}($));



// WEBPACK FOOTER //
// ./src/scrollto.js